const METADATA_INITIAL_STATE = {
  isLoading: false,
  error: undefined,
  data: {},
}

export default METADATA_INITIAL_STATE
